import {
  Autocomplete,
  Checkbox,
  Grid,
  InputLabel,
  List,
  ListItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';
import {
  checklistCompletedOption,
  machineList,
  speciesOptions,
  vehicalCheckListOption,
  yesNoOption,
} from '../Data/HFDropDowdData';
import { harvestingMaintanceVehicalCheckListoptionList, vehicalInspectionList } from '../Data/HfInputFieldsData';
import SectionAccordians from 'routes/Pages/components/Accordians/SectionAccordians';
import DetailedM3Table from './DetailedM3Table';
const dropDownStyles = {
  paddingBottom: '10px',
  fontSize: '0.825rem',
  color: 'black',
};
const autoCompleteSlotProps = {
  paper: {
    sx: {
      '& .MuiAutocomplete-option': {
        fontSize: '0.82rem',
        fontWeight: 500,
      },
    },
  },
};
const HF_HelpVideos = () => {
  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': {
          fontSize: '0.825rem',
        },
        '& .MuiInputBase-root': {
          fontSize: '0.825rem !important',
        },
        paddingBottom: '1rem',
      }}>
      <Typography variant="h5" sx={{ padding: '1rem' }}>
        Help Videos
      </Typography>
    </Grid>
  );
};

export default HF_HelpVideos;
